import { authorize, getRequest } from '../../../utils/http';
import { AWS_API_URL } from '../../../global/environment';

export async function getPairingStatusAPI(user) {
  const url = `${AWS_API_URL}/2n/users/mobile-key?email=${encodeURIComponent(user?.email)}`;

  return getRequest(url, await authorize());
}
